import {MobileDeviceData} from "../data/MobileDeviceData";

export class PlatformModel {
    public static mobileDeviceData: MobileDeviceData;
    public static isMac: boolean;
    public static isSafari: boolean;
    public static isFirefox: boolean;
}